import { FormLayout, Modal, TextField, Form, Select } from '@shopify/polaris';
import { useEffect, useState } from 'react';

import helpers from 'helpers';

import { lengthLessThan, notEmpty, useField, useForm } from '@shopify/react-form';

import __ from 'languages/index';
import { ChargePoint, useCreateChargeStation, useGetChargeStation, useUpdateChargeStation } from 'queries/charge_station.query';

/**
 *   Create upload Modal for Charge Station
 */

// eslint-disable-next-line import/no-anonymous-default-export

export default function ChargeStationModal({
  onClose,
  show,
  currentChargeStationId,
}: {
  onClose: Function;
  show: boolean;
  currentChargeStationId?: number | null;
}) {
  const { mutateAsync: createEntity, isPending: creating, isSuccess: creatingSuccess } = useCreateChargeStation();
  const { mutateAsync: updateEntity, isPending: updating, isSuccess: updateSuccess } = useUpdateChargeStation();
  const { mutateAsync: getChargeStation, data: chargeStationData } = useGetChargeStation();

  const [entity, setEntity] = useState<ChargePoint>(null);

  useEffect(() => {
    if (currentChargeStationId) {
      getChargeStation(currentChargeStationId);
    } else {
      setEntity(null);
    }
  }, [currentChargeStationId]);

  const useFields = {
    cpid: useField<string>({
      value: entity?.cpid ?? '',
      validates: [notEmpty('Không được để trống trường này.'), lengthLessThan(100, 'No more than 100 characters.')],
    }),

    name: useField<string>({
      value: entity?.name ?? '',
      validates: [notEmpty('Không được để trống trường này.'), lengthLessThan(250, 'No more than 250 characters.')],
    }),

    address: useField<string>({
      value: entity?.address ?? '',
      validates: [notEmpty('Không được để trống trường này.'), lengthLessThan(500, 'No more than 500 characters.')],
    }),

    gunCount: useField<string>({
      value: String(entity?.gunCount || 1),
      validates: [
        (inputVal) => {
          if (!helpers.isNumber(inputVal)) return 'Phải là một số hợp lệ.';
          if (Number(inputVal) < 1 || Number(inputVal) > 2) return 'Số cổng sạc không hợp lệ.';
        },
      ],
    }),

    maxPowerKw: useField<string>({
      value: entity?.maxPowerKw !== undefined && entity?.maxPowerKw !== null ? String(entity.maxPowerKw) : '',
      validates: [
        (inputVal) => {
          if (!inputVal) return;
          if (!helpers.isNumber(inputVal)) return 'Phải là một số hợp lệ.';
          if (Number(inputVal) < 0) return 'Công suất phải lớn hơn hoặc bằng 0.';
        },
      ],
    }),

    hotline: useField<string>({
      value: entity?.hotline ?? '',
      validates: [lengthLessThan(50, 'No more than 50 characters.')],
    }),
  };

  const {
    fields,
    submit,
    dirty,
    reset: resetForm,
  } = useForm({
    fields: useFields,

    async onSubmit(values) {
      try {
        const payload = {
          cpid: values.cpid,
          name: values.name,
          address: values.address,
          gunCount: values.gunCount ? helpers.parseNumeric(values.gunCount) : 1,
          maxPowerKw: values.maxPowerKw ? helpers.parseNumeric(values.maxPowerKw) : null,
          hotline: values.hotline || null,
        };

        if (!currentChargeStationId) {
          await createEntity(payload);
        } else {
          await updateEntity({
            id: currentChargeStationId,
            ...payload,
          });
        }
      } catch (e: any) {
        if (e.params !== undefined) {
          if (e.params.field !== undefined) {
            useFields[e.params.field].setError(__('check_this_field_again'));
          }
        }
      }
      return { status: 'success' };
    },
  });

  useEffect(() => {
    if (chargeStationData) {
      setEntity(chargeStationData);
      resetForm();
    }
  }, [chargeStationData, resetForm]);

  useEffect(() => {
    if (updateSuccess || creatingSuccess) {
      resetForm();
      onClose();
    }
  }, [updateSuccess, creatingSuccess]);

  useEffect(() => {
    if (!currentChargeStationId) {
      resetForm();
      setEntity(null);
    }
  }, [currentChargeStationId]);

  const Actual_page = (
    <Modal
      open={show}
      onClose={() => onClose()}
      title={currentChargeStationId ? 'Cập nhật trạm sạc' : 'Tạo trạm sạc'}
      primaryAction={{
        content: currentChargeStationId ? 'Cập nhật' : 'Tạo',
        disabled: !dirty,
        loading: updating || creating,
        onAction: submit,
      }}
      secondaryActions={[
        {
          content: 'Close',
          onAction: () => onClose(),
        },
      ]}
    >
      <Modal.Section>
        <Form onSubmit={submit}>
          <FormLayout>
            <TextField autoFocus autoComplete="off" requiredIndicator label="CPID" {...fields.cpid} />
            <TextField autoComplete="off" requiredIndicator label="Tên trạm sạc" {...fields.name} />
            <TextField autoComplete="off" requiredIndicator label="Địa chỉ" multiline={3} {...fields.address} />
            <FormLayout.Group>
              
              <Select label="Số cổng sạc" options={[
                {
                  label: "1 Cổng",
                  value: "1"
                },
                {
                  label: "2 Cổng",
                  value: "2"
                },
              ]} value={fields.gunCount.value} onChange={(v) => fields.gunCount.onChange(v)} />


              <TextField type="number" autoComplete="off" label="Công suất (kW)" {...fields.maxPowerKw} />
            </FormLayout.Group>
            <TextField autoComplete="off" label="Hotline" {...fields.hotline} />
          </FormLayout>
        </Form>
      </Modal.Section>
    </Modal>
  );

  return <>{Actual_page}</>;
}
